<script setup lang="ts">
import { useBoardDialogStore } from '@/stores/boardDialogStore';
import RadioButtons from './radio.vue';
import InformBox from './informBox.vue';
import { mockData } from '../mock';

const boardDialogStore = useBoardDialogStore();
const boardOption = computed(() => boardDialogStore.boardDialogOption);

const question = ref('');
const questionType = ref('');
const isDisabledSubmitButton = ref(true);

const handleClose = () => {
  console.log('read close');
  boardDialogStore.closeBoardDialog();
};

const validateForm = () => {
  if (!questionType.value) {
    alert('문의 유형을 선택해주세요.');
    return false;
  }
  if (!question) {
    alert('문의 내용을 입력해주세요.');
    return false;
  }
  return true;
};

watch([() => questionType.value, () => question.value], ([newQuestionType, newQuestion]) => {
  isDisabledSubmitButton.value = !(newQuestionType && newQuestion);
  console.log('라디오 버튼 값: ', newQuestionType);
  console.log('질문 값: ', newQuestion);
});

const handleSubmit = () => {
  if (validateForm()) {
    console.log('submit');
  }
};

onMounted(() => {
  console.log('qna/create Mounted');
  if (boardOption.value.type === 'update') {
    question.value = mockData.question;
    questionType.value = mockData.questionType;
  }
});
</script>

<template>
  <div class="title-row">
    <v-card-title class="card__title"> {{ boardOption.type === 'create' ? '질문하기' : '수정하기' }} </v-card-title>
    <VIcon
      class="title-row__icon"
      icon="ri-close-fill"
      size="27"
      @click="handleClose"
    />
  </div>
  <div class="type-row">
    <!-- 라디오 버튼 그룹 -->
    <RadioButtons v-model="questionType" />
  </div>
  <div class="textarea-row">
    <v-textarea
      class="textarea"
      placeholder="문의내용을 입력해주세요."
      variant="underlined"
      v-model="question"
      row="5"
      auto-grow
      clearable
      counter
      maxlength="500"
    ></v-textarea>
  </div>
  <!-- informBox로 추출 -->
  <InformBox />
  <v-card-actions class="button-row">
    <v-btn
      @click="handleSubmit"
      class="button-row__confirm"
      :disabled="isDisabledSubmitButton"
    >
      {{ boardOption.type === 'create' ? '등록' : '수정' }}
    </v-btn>
    <v-btn
      @click="handleClose"
      class="button-row__cancel"
    >
      취소
    </v-btn>
  </v-card-actions>
</template>

<style lang="scss" scoped>
.title-row {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  &__icon {
    /* background-color: red; */
    position: absolute;
    right: 0;
    top: 8px;
  }
}
.type-row {
  width: 100%;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
}
.textarea-row {
  width: 100%;
  margin-top: 10px;
}
.button-row {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  &__cancel {
    width: 20%;
    background-color: #f7f7f7;
    color: #a9a9a9;
    font-weight: 800;
  }
  &__confirm {
    width: 20%;
    background-color: #6c5ce7;
    color: white !important;
    font-weight: 800;
  }
}
</style>
